import ReplyOptionState from '../store/schema/ReplyOptionState';
import store from '../store/store';
import { updateUserConfiguration } from 'owa-options-core';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';

export interface SaveReplyOptionState {
    optionState: ReplyOptionState;
    userOptions: UserOptionsType;
}

export default select<SaveReplyOptionState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(
    action('saveReplyOption')(async function saveReplyOption(state?: SaveReplyOptionState) {
        let { optionState, userOptions } = state;

        userOptions.IsReplyAllTheDefaultResponse = optionState.replyAllByDefault;

        await updateUserConfiguration([
            {
                propertyName: 'IsReplyAllTheDefaultResponse',
                propertyType: 'Boolean',
                propertyValue: `${optionState.replyAllByDefault}`,
            },
        ]);
    })
);
